import { render, staticRenderFns } from "./Endnotenuebersicht.vue?vue&type=template&id=9fdda512"
import script from "./Endnotenuebersicht.vue?vue&type=script&lang=js"
export * from "./Endnotenuebersicht.vue?vue&type=script&lang=js"
import style0 from "./Endnotenuebersicht.vue?vue&type=style&index=0&id=9fdda512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports